import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-document-viewer',
  templateUrl: './document-viewer.component.html',
  styleUrls: ['./document-viewer.component.scss']
})
export class DocumentViewerComponent implements OnInit {
  currentDocumentIndex: number = 0;
  documents: any[] = [];

  constructor(
    private dialogRef: MatDialogRef<DocumentViewerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {    

    this.documents = this.data.documents || [];
    this.currentDocumentIndex = this.data.initialIndex || 0;
  }

  dialogClose(): void {
    this.dialogRef.close();
  }

  nextDocument(): void {
    if (this.currentDocumentIndex < this.documents.length - 1) {
      this.currentDocumentIndex++;
    }
  }

  previousDocument(): void {
    if (this.currentDocumentIndex > 0) {
      this.currentDocumentIndex--;
    }
  }

isImage(type?: string, mimeType?: string): boolean {
  const validImageTypes = [
    'image/jpeg', 'image/png', 'image/gif', 'image/webp',
    'image/jpg', 'image/bmp', 'image/svg+xml', 'image/tiff',
    'image/x-icon', 'image/heic', 'image/heif', 'image'
  ];

  const normalizedType = type?.toLowerCase();
  const normalizedMime = mimeType?.toLowerCase();

  return validImageTypes.includes(normalizedType) || validImageTypes.includes(normalizedMime);
}

  isVideo(type: string): boolean {
    return ['video/mp4','video/webm','video/ogg','video/quicktime','video/x-msvideo','video/x-matroska']
      .includes(type?.toLowerCase());
  }

  isPdf(type: string, mimeType?: string): boolean {
    
    return type?.toLowerCase() === 'application/pdf' || mimeType?.toLowerCase() === 'application/pdf';
  }

  isOfficeDoc(type: string): boolean {
    return [
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-powerpoint',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation'
    ].includes(type?.toLowerCase());
  }

  isText(type: string): boolean {
    return ['text/plain', 'application/rtf'].includes(type?.toLowerCase());
  }
}